import { Component, OnInit } from '@angular/core';
import { NotificationService, Notification } from '../../services/notification.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
  notifications: Notification[] = [];

  constructor(private notificationService: NotificationService) {}

  ngOnInit(): void {
    this.notificationService.getNotificationsStream().subscribe(data => {
      this.notifications = data;
    });

    this.notificationService.refresh();
  }

/*     ngOnInit(): void {
  this.notificationService.refresh().subscribe(data => {
    this.notifications = data;
  });
} */

  markAsRead(id: string): void {
    this.notificationService.markAsRead(id).subscribe(() => {
      this.notificationService.refresh();
    });
  }

  deleteNotification(id: string): void {
    if (confirm('¿Estás seguro de que deseas eliminar esta notificación?')) {
      this.notificationService.delete(id).subscribe(() => {
        this.notificationService.refresh();
      });
    }
  }
}
